<div class="max-auto">
    <div class="sa-title-panel plMd d-flex flex-{{textAlign}} align-center">
        <h1 class="h2 text-{{textColor}}">{{ title }}</h1>
    </div>
</div>
